import React, { useEffect, useRef, useState } from "react";
import { postData1 } from "../../../services";
import axios from "axios";
import CommunicationMessage from "./CommunicationMessage";
import { Forward, Paperclip, FileText, X } from "lucide-react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import PersonalContactDetails from "./PersonalContactDetails";
import DashboardDetails from "./DashboardDetails";
import BusinessContactDetails from "./BusinessContactDetails";
import AdminActions from "./AdminActions";
import ProductActivitySection from "./ProductActivitySection";
import InvoiceCustom from "../ActivityLogs/InvoiceCustom";

const CommunicationInbox = ({ userUid, userData }) => {
    console.log("userData in CommunicationInbox", userData.mobile);

    const mappedOrderData = {
        buyer_firstname: userData?.profile?.first_name,
        buyer_lastname: userData?.profile?.last_name,
        delivery_address: {
            address: userData?.profile?.address,
            gstin: userData?.profile?.gstin,
            mobile: userData?.mobile,
        },
    };

    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState("");

    const [loading, setLoading] = useState(false);
    const [sending, setSending] = useState(false);

    const [selectedFile, setSelectedFile] = useState(null);
    const [messageType, setMessageType] = useState("text");
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [fetchUserData, setFetchUserData] = useState(null);

    const chatRef = useRef(null);
    const navigate = useNavigate();

    const adminUid = localStorage.getItem("adminUid");

    useEffect(() => {

        if (userUid) {

            getChats();

        }

    }, [userUid]);

    useEffect(() => {

        scrollBottom();

    }, [messages]);

    const scrollBottom = () => {

        if (chatRef.current) {

            chatRef.current.scrollTop =
                chatRef.current.scrollHeight;

        }

    };
    const handleFileChange = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        setSelectedFile(file);

        if (file.type.startsWith("image/")) {

            setMessageType("image");

        }
        else if (file.type === "application/pdf") {

            setMessageType("pdf");

        }
        else if (file.type.startsWith("video/")) {

            setMessageType("video");

        }
        else {

            setMessageType("file");

        }

    };

    const handleSendInvoice = async (pdfBlob) => {
        // Create a File object from blob
        const fileName = `Invoice-${Date.now()}.pdf`;
        const file = new File([pdfBlob], fileName, { type: 'application/pdf' });

        // Set the file and send it as a message
        // We can use the existing sendMessage function, but we need to set the file in state.
        // Since sendMessage uses state, we can set the file and message, then call sendMessage.
        // But we need to avoid interfering with the current input.
        // So we directly call the API with the file.

        try {
            setSending(true);
            const formData = new FormData();
            formData.append("receiver_uid", userUid);
            formData.append("message", "Please find the attached quotation.");
            formData.append("message_type", "pdf"); // or 'file'
            formData.append("file", file);

            const token = localStorage.getItem("adminAuth");
            const response = await axios.post(
                `${BaseURL}/admin/admin_send_message/`,
                formData,
                {
                    headers: {
                        Authorization: `Token ${token}`
                    }
                }
            );
            if (response.data?.status_code === 200) {
                // Optionally close modal and refresh chats
                setShowInvoiceModal(false);
                getChats();
                // Also clear any selected file in the main input? Not needed.
            }
        } catch (err) {
            console.error('Failed to send invoice:', err);
        } finally {
            setSending(false);
        }
    };

    const BaseURL = process.env.REACT_APP_BASEURL;

    const getChats = async () => {

        try {

            setLoading(true);

            const res = await postData1(

                "admin/admin_chat/",

                {
                    uid: userUid
                },

                true,
                true

            );

            if (res?.status_code === 200) {

                setMessages(res.data || []);

            }

        } catch (err) {

            console.log(err);

        } finally {

            setLoading(false);

        }

    };


    const sendMessage = async () => {

        if (!message.trim() && !selectedFile) return;

        try {

            setSending(true);

            const formData = new FormData();

            formData.append("receiver_uid", userUid);
            formData.append("message", message);
            formData.append("message_type", messageType);

            if (selectedFile) {

                formData.append("file", selectedFile);

            }

            const token = localStorage.getItem("adminAuth");

            const response = await axios.post(

                `${BaseURL}/admin/admin_send_message/`,

                formData,

                {

                    headers: {

                        Authorization: `Token ${token}`

                    }

                }

            );

            const res = response.data;

            if (res?.status_code === 200) {

                setMessage("");

                setSelectedFile(null);

                setMessageType("text");

                document.getElementById("chatAttachment").value = "";

                getChats();

            }

        } catch (err) {

            console.log(err.response);

        } finally {

            setSending(false);

        }

    };

    const handleKeyDown = (e) => {

        if (
            e.key === "Enter" &&
            !e.shiftKey
        ) {

            e.preventDefault();

            sendMessage();

        }

    };

    const handleWhatsAppShare = () => {
        console.log("userData", userData);
        const phone = userData?.mobile; // Country code without +

        const link = "https://www.equipmedy.com/dashboard/inbox";

        const message = `Dear ${userData?.profile?.first_name || "there"},

Please find your quotation of your Product .
Quotation link:- 
${link}

If you have any questions or require any changes, please feel free to contact us.
Thank you for choosing EquipMedy.`;

        window.open(
            `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
            "_blank"
        );
    };

    const handleOpenInvoiceModal = async () => {
        try {
            const res = await postData1("admin/user_details/",
                { uid: userUid },
                true,
                true
            );
            if (res?.status_code === 200) {
                setFetchUserData(res?.data);
            } else {
                setFetchUserData(userData);
            }
        } catch (err) {
            console.log(err);
            setFetchUserData(userData);
        }
        setShowInvoiceModal(true);
    };

    const handleNavigateToInvoice = () => {
        const invoiceData = fetchUserData || userData;
        const orderData = {
            buyer_firstname: invoiceData?.profile?.first_name || "",
            buyer_lastname: invoiceData?.profile?.last_name || "",
            delivery_address: {
                address: invoiceData?.profile?.location || "",
                mobile: invoiceData?.mobile || "",
                gstin: invoiceData?.profile?.gstin || "",
            },
            uid: invoiceData?.uid || userUid,
            product_detail: {
                equip_name: "",
                description: "",
                brand: "",
                model: "",
                subcategory: "",
            },
            asking_price: 0,
            discount: 0,
            paid_amount: 0,
            sub_total: 0,
            tax: 0,
            total: 0,
            remain_amount: 0,
            invoiceNo: `INV-${invoiceData?.uid?.substring(0, 8) || "000000"}`,
        };
        navigate("/admin/custom-invoice-generator/", { state: orderData });
    };

    return (

        <div className="bg-white rounded-lg shadow border h-full flex flex-col">

            {/* Header */}

            <div className="border-b px-5 py-4 flex items-center justify-between">

                <div>

                    <h2 className="text-xl font-semibold">

                        Communication Inbox

                    </h2>

                    <p className="text-sm text-gray-500">

                        Chat with User

                    </p>

                </div>

                <div className="flex items-center gap-2">

                    <Button
                        title="Generate Invoice"
                        onClick={handleOpenInvoiceModal}
                        className="flex items-center gap-2 bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 transition"
                    >
                        <FileText size={18} />
                        Invoice
                    </Button>

                    <Button
                        title="Share on WhatsApp"
                        onClick={handleWhatsAppShare}
                        className="flex items-center gap-2 bg-[#219d8e] text-white px-2 py-2 rounded-lg transition"
                    >
                        <Forward size={18} />

                    </Button>

                </div>

            </div>

            {/* Chat Body */}

            <div
                ref={chatRef}
                className="flex-1 overflow-y-auto bg-gray-50 p-5"
            >

                {
                    loading ?

                        <div className="h-full flex justify-center items-center">

                            Loading...

                        </div>

                        :

                        messages.length === 0 ?

                            <div className="h-full flex justify-center items-center text-gray-400">

                                No Conversation Found

                            </div>

                            :

                            messages.map((item) => (

                                <CommunicationMessage
                                    key={item.uid}
                                    message={item}
                                    adminUid={adminUid}
                                />

                            ))

                }

            </div>

            {/* Selected File */}

            {

                selectedFile &&

                <div className="px-5 py-2 border-t bg-gray-50">

                    <div className="flex items-center justify-between">

                        <div>

                            <p className="font-medium text-sm">

                                {selectedFile.name}

                            </p>

                            <p className="text-xs text-gray-500">

                                {(selectedFile.size / 1024).toFixed(2)} KB

                            </p>

                        </div>

                        <button

                            onClick={() => {

                                setSelectedFile(null);

                                setMessageType("text");

                                document.getElementById("chatAttachment").value = "";

                            }}

                            className="text-red-500"

                        >

                            ✕

                        </button>

                    </div>

                </div>

            }

            {/* Footer */}

            <div className="border-t p-4">

                <div className="flex items-end gap-3">



                    {/* Message */}

                    <textarea

                        rows={2}

                        value={message}

                        onChange={(e) => setMessage(e.target.value)}

                        onKeyDown={handleKeyDown}

                        placeholder="Type message..."

                        className="flex-1 border rounded-lg p-3 resize-none outline-none focus:ring-2 focus:ring-blue-500"

                    />

                    {/* Attachment */}

                    <label

                        htmlFor="chatAttachment"

                        className="cursor-pointer border rounded-lg h-12 w-12 flex items-center justify-center hover:bg-gray-100"

                    >

                        <Paperclip />

                    </label>

                    <input

                        id="chatAttachment"

                        type="file"

                        hidden

                        onChange={handleFileChange}

                    />

                    {/* Send */}

                    <button

                        onClick={sendMessage}

                        disabled={sending}

                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 h-12 rounded-lg"

                    >

                        {

                            sending ?

                                "Sending..."

                                :

                                "Send"

                        }

                    </button>

                </div>

            </div>

            {/* Invoice Modal */}
            {showInvoiceModal && (
                <div className="fixed inset-0 z-[99999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto">
                    <div className="bg-white rounded-3xl shadow-2xl w-full max-w-6xl max-h-[95vh] overflow-hidden my-8">
                        {/* Header */}
                        <div className="flex items-center justify-between border-b px-6 py-5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white sticky top-0 z-10">
                            <div>
                                <h2 className="text-2xl font-bold !text-white">
                                    Generate Invoice
                                </h2>
                                <p className="text-sm text-white/80 mt-1">
                                    {fetchUserData?.profile?.first_name
                                        ? `${fetchUserData.profile.first_name} ${fetchUserData.profile.last_name || ""}`
                                        : "User Details"}
                                </p>
                            </div>
                            <div className="flex items-center gap-3">
                                <button
                                    onClick={() => setShowInvoiceModal(false)}
                                    className="p-2 rounded-xl hover:bg-white/20 transition"
                                >
                                    <X size={24} />
                                </button>
                            </div>
                        </div>

                        {/* Body - Scrollable */}
                        <div className="overflow-y-auto max-h-[calc(95vh-80px)] p-6 space-y-6">
                            {fetchUserData ? (
                                <InvoiceCustom userDatas={mappedOrderData} invoiceType="viachat" onShareQuotation={(blob) => { handleSendInvoice(blob) }} />
                            ) : (
                                <div className="flex items-center justify-center py-20">
                                    <p className="text-gray-500 text-lg">Loading user details...</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

        </div>

    );

};

export default CommunicationInbox;